module.exports = __webpack_public_path__ + "img/collecting.adf85f3d.svg";